(function() {
  let scriptsLoaded = false;
  let cartScriptsLoaded = false;

  const cartScriptPattern = /d39va5bdt61idd\.cloudfront\.net|cartAnimate|carttrack|ctxcollect\.com/i;

  function isCartScript(script) {
    const src = script.getAttribute('data-src') || script.getAttribute('src') || '';
    return cartScriptPattern.test(src);
  }

  const releasedGoogleScripts = new WeakSet();
  const observedGoogleSdkScripts = new WeakSet();

  function existingGoogleTagUrl(src) {
    if (!src) return null;
    try {
      const url = new URL(src, window.location.href);
      const ids = url.searchParams.getAll('id');
      const id = ids[0];
      const knownSdk = url.pathname === '/gtag/js' && (id === 'GT-PHCDRJ3R' || id === 'G-8ZW5BJNP24');
      const knownDestination = url.pathname === '/gtag/destination' && id === 'G-8ZW5BJNP24';
      if (url.origin !== 'https://www.googletagmanager.com' || url.username || url.password ||
          ids.length !== 1 || (!knownSdk && !knownDestination)) return null;
      url.hash = '';
      url.searchParams.sort();
      return url.href;
    } catch (ignore) { return null; }
  }

  function observeExistingGoogleSdkLoad(script, key) {
    if (!key || observedGoogleSdkScripts.has(script)) return;
    const url = new URL(key);
    if (url.pathname !== '/gtag/js' || typeof script.addEventListener !== 'function') return;
    observedGoogleSdkScripts.add(script);
    script.addEventListener('load', function(event) {
      if (!event || event.isTrusted === false || window.__bhKnownGoogleTagLoaded === true) return;
      window.__bhKnownGoogleTagLoaded = true;
      if (typeof window.Event === 'function' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new window.Event('bh:known-google-tag-loaded'));
      }
    }, { once: true });
    script.addEventListener('error', function() {
      // A later failed SDK must not erase an earlier actual successful load.
      if (window.__bhKnownGoogleTagLoaded !== true) window.__bhKnownGoogleTagLoaded = false;
    }, { once: true });
  }

  // Release only an already present authenticated analytics tag/destination after the official
  // Shopify privacy API permits analytics. Do not configure a destination,
  // release other integrations, or change the normal lazy-loading readiness.
  window.__bhReleaseExistingGoogleTag = function() {
    try {
      const configNode = document.getElementById('bh-tracking-config');
      if (!configNode) { window.__bhGoogleTagMayLoad = false; return 0; }
      const config = JSON.parse(configNode.textContent || '{}');
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (config.enabled !== true || !config.ga4 || config.ga4.route !== 'reuse' ||
          !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
          privacy.analyticsProcessingAllowed() !== true) {
        window.__bhGoogleTagMayLoad = false;
        return 0;
      }

      const scripts = Array.from(document.querySelectorAll('script[src], script[data-src]'));
      const activeUrls = new Set();
      scripts.forEach(script => {
        if (script.getAttribute('type') === 'text/lazyload') return;
        const key = existingGoogleTagUrl(script.getAttribute('src'));
        if (key) {
          activeUrls.add(key);
          observeExistingGoogleSdkLoad(script, key);
        }
      });
      // The existing theme interception checks this narrow permission before
      // handling the authenticated GT/G8 SDK and G8 destination. Other tags stay deferred.
      window.__bhGoogleTagMayLoad = true;
      let released = 0;
      scripts.forEach(script => {
        if (script.getAttribute('type') !== 'text/lazyload' || releasedGoogleScripts.has(script)) return;
        const src = script.getAttribute('data-src') || script.getAttribute('src');
        const key = existingGoogleTagUrl(src);
        if (!key) return;
        if (activeUrls.has(key)) {
          releasedGoogleScripts.add(script);
          script.remove();
          return;
        }
        try {
          const newScript = document.createElement('script');
          Array.from(script.attributes).forEach(attr => {
            const name = attr.name.toLowerCase();
            if (['id', 'nonce', 'crossorigin', 'integrity', 'referrerpolicy', 'fetchpriority', 'charset'].includes(name) ||
                (name.startsWith('data-') && name !== 'data-src')) newScript.setAttribute(name, attr.value);
          });
          if (script.nonce) newScript.nonce = script.nonce;
          newScript.async = true;
          observeExistingGoogleSdkLoad(newScript, key);
          newScript.setAttribute('src', src);
          document.head.appendChild(newScript);
          activeUrls.add(key);
          releasedGoogleScripts.add(script);
          script.remove();
          released += 1;
        } catch (ignore) {
          // Leave the original deferred element available to the ordinary loader.
        }
      });
      return released;
    } catch (ignore) { window.__bhGoogleTagMayLoad = false; return 0; }
  };

  function hydrateLazyScript(script) {
    const newScript = document.createElement('script');
    Array.from(script.attributes).forEach(attr => {
      if (attr.name !== 'type' && attr.name !== 'data-src') {
        newScript.setAttribute(attr.name, attr.value);
      }
    });
    if (script.hasAttribute('data-src')) {
      newScript.setAttribute('src', script.getAttribute('data-src'));
    }
    if (script.innerHTML) {
      newScript.innerHTML = script.innerHTML;
    }
    document.head.appendChild(newScript);
  }

  function hydrateLazyCartLink(link) {
    if (link.hasAttribute('data-href')) {
      link.setAttribute('href', link.getAttribute('data-href'));
      link.removeAttribute('data-href');
      link.removeAttribute('data-cart-lazyload');
    }
  }
  
  function loadLazyScripts() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;
    window.lazyloadScriptsReady = true;
    
    const lazyScripts = document.querySelectorAll('script[type="text/lazyload"]');
    
    lazyScripts.forEach(script => {
      if (!isCartScript(script)) {
        hydrateLazyScript(script);
      }
    });

    const lazyIframes = document.querySelectorAll('iframe[data-src]');
    lazyIframes.forEach(iframe => {
      iframe.setAttribute('src', iframe.getAttribute('data-src'));
      iframe.removeAttribute('data-src');
    });

    
    window.removeEventListener('scroll', loadLazyScripts);
    window.removeEventListener('mousemove', loadLazyScripts);
    window.removeEventListener('touchstart', loadLazyScripts);
    window.removeEventListener('pointerdown', loadLazyScripts);
    window.removeEventListener('click', loadLazyScripts);
    window.removeEventListener('keydown', loadLazyScripts);
  }

  function loadCartScripts() {
    if (cartScriptsLoaded) return;
    cartScriptsLoaded = true;
    window.lazyloadCartScriptsReady = true;

    document.querySelectorAll('script[type="text/lazyload"]').forEach(script => {
      if (isCartScript(script)) {
        hydrateLazyScript(script);
      }
    });
    document.querySelectorAll('link[data-cart-lazyload][data-href]').forEach(hydrateLazyCartLink);

    window.removeEventListener('pointerdown', handleCartIntent, true);
    window.removeEventListener('click', handleCartIntent, true);
    window.removeEventListener('keydown', handleCartIntent, true);
  }

  function hasCartIntent(target) {
    if (!target || !target.closest) return false;
    return !!target.closest('a[href*="/cart"], a[href*="checkout"], form[action*="/cart/add"], button[name="add"], product-form, cart-drawer, cart-notification, quick-add-modal, .quick-add, .cart, [data-cart]');
  }

  function handleCartIntent(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (hasCartIntent(event.target)) {
      loadCartScripts();
    }
  }

  window.addEventListener('scroll', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('mousemove', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('touchstart', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('pointerdown', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('click', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('keydown', loadLazyScripts, {once: true, passive: true});
  window.addEventListener('pointerdown', handleCartIntent, true);
  window.addEventListener('click', handleCartIntent, true);
  window.addEventListener('keydown', handleCartIntent, true);
  
  // The synchronous header may record the first real interaction before this
  // deferred file executes. Replay only that existing signal; do not make
  // unvisited pages eager or release cart-only scripts.
  if (window.__bhNewsletterFirstInteraction > 0) {
    loadLazyScripts();
  }

  if (!window.__bhPerformanceTest && !window.navigator.webdriver && navigator.userAgent.indexOf('Lighthouse') === -1 && navigator.userAgent.indexOf('Chrome-Lighthouse') === -1 && navigator.userAgent.indexOf('PageSpeed') === -1 && navigator.userAgent.indexOf('Speed Insights') === -1) {
    setTimeout(function() {
      loadLazyScripts();
      loadCartScripts();
    }, 30000);
  }
})();
